import {
    Box,
    Button,
    Container,
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    Step,
    StepButton,
    StepLabel,
    Stepper,
    Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Spacer } from "../../components/spacer";
import dataProvider from "../../providers/data-provider";
import _ from "lodash";

const QuizResolutionPage = ({ quiz }) => {
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [answers, setAnswers] = useState({});
    const [answered, setAnswered] = useState({});
    const [timeLeft, setTimeLeft] = useState(quiz.time_to_solve ? quiz.time_to_solve * 60 : null);

    const questions = quiz.questions

    questions.forEach((question) => question.alternatives = _.shuffle(question.alternatives))

    const currentQuestion = questions[currentQuestionIndex];

    useEffect(() => {
        if (timeLeft !== null) {
            const timer = setInterval(() => {
                setTimeLeft((prevTime) => {
                    if (prevTime <= 1) {
                        clearInterval(timer);
                        alert("O tempo acabou!");
                        return 0;
                    }
                    return prevTime - 1;
                });
            }, 1000);

            return () => clearInterval(timer);
        }
    }, [timeLeft]);

    const handleAnswerChange = (alternativeId) => {
        setAnswers({
            ...answers,
            [currentQuestion.id]: alternativeId,
        });
        setAnswered({
            ...answered,
            [currentQuestion.id]: true
        })
    };

    const handleNext = () => {
        if (currentQuestionIndex < questions.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        };
    }

    const handlePrevious = () => {
        if (currentQuestionIndex > 0) {
            setCurrentQuestionIndex(currentQuestionIndex - 1);
        }
    }

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
    };

    const handleSubmitQuiz = () => {

        const parsed = Object.keys(answers).map((key) => {
            return { question_id: key, alternative_id: answers[key] }
        })

        dataProvider.post('quiz', quiz.id, { answers: parsed }).then((res) => {

        })
    }

    return (
        <Container maxWidth="lg" style={{ marginTop: "2rem" }}>
            <Typography variant="h4" gutterBottom>
                Resolução do Quiz
            </Typography>

            {timeLeft !== null && (
                <Box textAlign="right" marginBottom="1rem">
                    <Typography variant="h6" color="secondary">
                        Tempo restante: {formatTime(timeLeft)}
                    </Typography>
                </Box>
            )}

            <Stepper style={{ borderRadius: '8px' }} nonLinear activeStep={currentQuestionIndex} alternativeLabel>
                {questions.map((q, index) => (
                    <Step key={index}>
                        <StepButton onClick={() => { setCurrentQuestionIndex(index) }} completed={answered[q.id]}>
                            {questions.length <= 10 && <StepLabel>{`Questão ${index + 1}`}</StepLabel>}
                        </StepButton>
                    </Step>
                ))}
            </Stepper>

            <Box marginTop="2rem">
                <Typography variant="h6" color="textSecondary" align="justify" gutterBottom>
                    {`(${currentQuestion?.source?.name?.trim()}) Questão ${currentQuestion?.number?.trim()}`}
                </Typography>
                <Typography variant="h6" color="textSecondary" align="justify" gutterBottom>
                    {`${currentQuestion.text}`}
                </Typography>
                {currentQuestion.observations && (
                    <Typography variant="body2" color="textSecondary" gutterBottom>
                        {currentQuestion.observations}
                    </Typography>
                )}

                <FormControl component="fieldset">
                    <RadioGroup
                        style={{ marginTop: '2rem' }}
                        value={answers[currentQuestion.id] || ""}
                        onChange={(e) => handleAnswerChange(e.target.value)}
                    >
                        {currentQuestion.alternatives.map((alt) => (
                            <FormControlLabel
                                style={{ marginBlock: '0.5rem' }}
                                key={alt.id}
                                value={alt.id}
                                control={<Radio />}
                                label={alt.text}
                            />
                        ))}
                    </RadioGroup>
                </FormControl>

                <Box display='flex' marginTop="2rem">

                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handlePrevious}
                        disabled={currentQuestionIndex === 0}
                        style={{ marginRight: '8px' }}
                    >
                        Anterior
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleNext}
                        disabled={currentQuestionIndex === questions.length - 1}
                    >
                        Próxima
                    </Button>
                    <Spacer />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmitQuiz}
                        disabled={timeLeft > 1 && Object.keys(answered).length < questions.length}
                    >
                        Finalizar
                    </Button>
                </Box>
            </Box>
        </Container>
    );
};

export default QuizResolutionPage;
